import { useState } from 'react';
import { Stack, Typography, Tooltip, Button } from '@mui/material';
import BuildIcon from '@mui/icons-material/Build';
import { COLORS } from '../../../utils/Application_Constants';
import CorrectionModal from './CorrectionModal';
import { useToast } from '../../Contexts/ToastContext';

const CorrectionCard = ({ id }) => {
    const [openConfirmationModal, setOpenConfirmationModal] = useState(false);
    const { showErrorToast } = useToast();

    const handleNewVersionSuccess = (newProcessedTimesheetId) => {
        setOpenConfirmationModal(false);

        if (newProcessedTimesheetId) {
            try {
                // open the new processed timesheet page in a new tab with corrections toast query param
                window.open(
                    `/#/processed-timesheets/${newProcessedTimesheetId}?showCorrectionsSuccessToast=true`,
                    '_blank'
                );
            } catch (err) {
                console.error('Failed to navigate to new processed timesheet page:', err);
            }
        }
    };

    return (
        <>
            <Stack alignItems="left" gap={2}>
                <Stack direction="row" alignItems="left" spacing={0.5} textAlign="left">
                    <Typography fontWeight="600" fontSize="16px" color={COLORS.LT_JOURNEY175}>
                        Start a Correction
                    </Typography>
                    <Tooltip title="This booking has corrections">
                        <BuildIcon
                            sx={{
                                color: COLORS.LT_POMEGRANATE75,
                                verticalAlign: 'middle',
                                width: 19,
                                height: 19,
                            }}
                        />
                    </Tooltip>
                </Stack>
                <Stack spacing={1} alignItems="left">
                    <Typography
                        fontSize={14}
                        color={COLORS.LT_MIDNIGHT50}
                        lineHeight="18px"
                        fontWeight="400"
                    >
                        This action creates a new version of the Processed Timesheet. The new
                        version will not go through the Rules Engine again.
                    </Typography>
                    <Button
                        sx={{ width: 'auto', alignSelf: 'flex-start' }}
                        variant="contained"
                        fontSize={16}
                        onClick={() => {
                            setOpenConfirmationModal(true);
                        }}
                    >
                        Create a new version
                    </Button>
                </Stack>
            </Stack>
            {openConfirmationModal && (
                <CorrectionModal
                    id={id}
                    onClose={() => setOpenConfirmationModal(false)}
                    onSuccess={handleNewVersionSuccess}
                    onError={(errorMessage) => showErrorToast(errorMessage)}
                />
            )}
        </>
    );
};

export default CorrectionCard;
